import React from 'react';
import { componentService } from 'js/services/component.service';

export const RealityCheck = React.lazy(() => import(/* webpackChunkName: "reality-check" */ './RealityCheck'));

componentService.registerPageComponents({ 'reality-check': RealityCheck });
